import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext.tsx";

const ProtectedRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    // You can replace this with a beautiful loading spinner
    return <div>Loading application...</div>;
  }

  // If the user is authenticated, render the nested routes (children).
  // Otherwise, redirect them to the login page.
  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
